<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="stock"
      :search="search"
      disable-initial-sort
      :rows-per-page-items="[100, 150, 200, 250]"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr
          :style="{backgroundColor: (props.item.price == '0' ? '#ffffff' : props.item.price == '' ? '#ffffff': '#1976d21A' ) }"
        >
          <td class="text-xs-right">
            <b>DO{{ props.item.do_id }}</b>
          </td>
          <td>
            <v-avatar size="38">
              <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
            </v-avatar>
          </td>
          <td class="text-xs-right">{{ props.item.product_name }}</td>
          <td class="text-xs-right">{{ props.item.grade }}</td>
          <td class="text-xs-right">{{ props.item.location }}</td>
          <td class="text-xs-right">{{ props.item.weight_type }}</td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>

          <td class="text-xs-right">
            <v-text-field
              v-model="props.item.price"
              label="price"
              v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"
              type="number"
              @focus="$event.target.select()"
              :placeholder="props.item.price"
            ></v-text-field>
          </td>

          <td class="text-xs-right">{{ props.item.product_stocked_date }}</td>
          <td class="text-xs-right">{{ parseFloat(props.item.quantity * props.item.weight * props.item.price).toFixed(2) }}</td>
          <td class="justify-end layout px-5">
            <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
            <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="getInvoiceItem(invoice_id,customer_id)"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/edit_dialog";
import { debounce } from "lodash";

export default {
  components: {
    edit_dialog
  },
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    errors: "",
    baseUrl: baseUrl,
    headers: [
      { text: "DO", align: "left", value: "do_id" },
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "left", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Locate", align: "right", value: "location" },
      { text: "KG", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "$$perKG", align: "left", value: "price" },
      { text: "Veg From", align: "right", value: "product_stocked_date" },
      { text: "Amount", align: "right", value: "" },
      { text: "tools", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    snackbar_response: false,
    response: "",
    type_need_weight: false,
    dialog_edit: false,
    invoice_id: "",
    customer_id:""
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {},

  methods: {
    getInvoiceItem: function(invoice_id,customer_id) {
      this.stock =[];
      this.dialog_edit = false;
      const params = new URLSearchParams();
      this.invoice_id = invoice_id;
      this.customer_id = customer_id;
      params.append("getInvoiceItem", "getInvoiceItem");
      params.append("invoice_id", this.invoice_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.stock = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deleteDOStock", "deleteDOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getInvoiceItem(this.invoice_id);
            this.snackbar_response = true;
            this.response = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.snackbar_response = true;
            this.response = response.data.data;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    DebounceUpdatePrice: _.debounce(function(id, price) {
      this.updatePrice(id, price);
    }, 300),
    updatePrice(id, price) {
      const params = new URLSearchParams();
      params.append("updatePrice", "updatePrice");
      params.append("id", id);
      params.append("price", price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response.data);
          if (response.data.error == false) {
            // this.fetch_do_item();

            this.snackbar_response = true;
            this.response = response.data.message;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    editItem(id) {
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id,this.customer_id);
    }
  }
};
</script>

